import * as d3 from 'd3'
import React from 'react'

import { settingsZoomLevel } from '../../utils/constants'
import { ZoomContainer } from './styles'

interface IProps {
    scale: number
    zoomBehaviour: d3.ZoomBehavior<Element, unknown>
    target: d3.Selection<SVGSVGElement, unknown, HTMLElement, any>
}

export const ZoomHandler: React.FC<IProps> = ({ scale, zoomBehaviour, target }) => {
    return (
        <ZoomContainer>
            <div
                className={`minus${scale <= settingsZoomLevel[0] ? ' disabled' : ''}`}
                onClick={() => scale > settingsZoomLevel[0] && zoomBehaviour?.scaleTo(target, scale - 0.05)}
            >
                <i className="fas fa-minus" />
            </div>
            <div className="range">
                <input
                    type="range"
                    min={settingsZoomLevel[0]}
                    value={scale}
                    onChange={e => e?.target?.value && zoomBehaviour?.scaleTo(target, Number(e.target.value))}
                    max={settingsZoomLevel[1]}
                    step="0.05"
                />
            </div>
            <div
                className={`plus${scale >= settingsZoomLevel[1] ? ' disabled' : ''}`}
                onClick={() => scale < settingsZoomLevel[1] && zoomBehaviour?.scaleTo(target, scale + 0.05)}
            >
                <i className="fas fa-plus" />
            </div>
        </ZoomContainer>
    )
}
